<template>
  <circle-image-button
    :image="annotationImage"
    :title="title"
    @click="$emit('click', $event)"
    :active="isActive"
    :size="size"
    :disabled="disabled"
    btnClass="primary"/>
</template>

<script>
import { getAnnotationType } from "../../../canvas/canvasUtils";
import circleImageButton from "../../controls/CircleImageButton";
export default {
  name: "annotationModeButton",
  components: { circleImageButton },
  props: {
    image: String,
    activeImage: String,
    buttonMode: Number,
    title: String,
    size: { type: String, default: "small"},
    disabled: Boolean,
    annotationMode: Number,
    activeAnnotation: Object
  },
  computed: {
    activeIsContinuous(){
      return this.activeAnnotation && this.activeAnnotation.isContinuous;
    },
    isActive(){
      if (this.annotationMode == this.buttonMode) return true;
      if (!this.activeIsContinuous) return false;
      let annotationType = getAnnotationType(this.buttonMode);
      return this.activeAnnotation.constructor == annotationType;
    },
    annotationImage() {
      return this.isActive ? this.activeImage : this.image;
    }
  }
};
</script>